<template>
	<div>
		<div class="pg-breadcrumb">
            <div class="breadcrumb-item em">好物兌換商品</div>
            <div class="breadcrumb-item">好物兌換-商品分類</div>
        </div>
		<div class="card-block">
            <Form inline class="pg-form-inline">
                <FormItem>
                    <Input style="width: 150px;" clearable v-model="name"
                           @keyup.enter.native="handleSearch()" placeholder="商品ID"></Input>
                </FormItem>
                <FormItem>
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style1" @click="handleSearch">搜索</div>
                    </div>
                </FormItem>
            </Form>
        </div>
		<div class="table-box">
			<div class="pg-btn-wrap add">
				<div class="pg-btn style2" @click="handleShowModal('add')">添加分類</div>
			</div>
			<Table row-key="id" ref="selection" :columns="table.columns" :data="table.data" border>
				<template slot-scope="{ row, index }" slot="action">
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style2" @click="handleShowModal('edit',row)">修改</div>
                        <div class="pg-btn style1" @click="handleDEL(row)">刪除</div>
                    </div>
                </template>
				<template slot-scope="{ row, index }" slot="status">
                     <Switch v-model="row.status" @on-change="changeStatus(row)" />
                </template>
			</Table>
		</div>
		
		
		
		<Modal v-model="isShowModa"
		       title="新增/修改"
		       width="400"
		       :footer-hide="true"
		       @on-cancel="handleModalClose">
            <div class="modal-cont">
                <Form>
                    <FormItem>
	                    <label class="input-label">上级分类：</label>
	                    <Select size="large" placeholder="请选择" clearable v-model="form.pid">
                            <Option :value="item.id" v-for="(item, index) in orderTypes" :key="item.id">
	                            {{ item.name }}
                            </Option>
                        </Select>
                    </FormItem>
	                <FormItem>
		                <label class="input-label"> * 分類名稱：</label>
		                <Input size="large" type="text" v-model="form.name" placeholder="請輸入"></Input>
	                </FormItem>
	                 <FormItem>
		                <label class="input-label"> * 排序：</label>
		                <Input size="large" type="text" v-model="form.sort" placeholder="請輸入"></Input>
	                </FormItem>
                    <FormItem>
                        <div class="pg-btn-wrap">
                            <div class="pg-btn style1" @click="handleConfirm">确定</div>
                        </div>
                    </FormItem>
                </Form>
            </div>
        </Modal>
	</div>
</template>

<script>
export default {
	name: "commodityTypes",
	data() {
		return {
			name: '', // 搜索
			form: {
				id:'',
				pid: '0', // 上级分贝
				name: '', // 分类名称
				sort: '' // 分类排序
			},
			table: {
				columns: [
					{
						title: '分類名稱',
						key: 'name',
						tree: true
					},
					{
						title: '排序',
						key: 'sort'
					},
					{
						title: '操作',
						action: true,
						slot: 'action'
					}
				],
				data: [],
			},
			
			orderTypes: [],
			isShowModa: false,
			modalType: ''
		}
	},
	created() {
		this.getList();
		this.getTyleslist();
	},
	methods: {
		// 获取列表
		getList() {
			this.$Rq.requestAuth({
				url: this.$Api.ordertypeList,
				method: 'get'
			}).then((res) => {
				if (res.code == 0) {
					this.table.data = res.data.data
				}else{
					this.table.data = []
				}
			})
		},
		// 點擊搜索
		handleSearch() {
			if (this.name != '') {
				this.$Rq.requestAuth({
					url: this.$Api.ordertypeOnList,
					method: 'get',
					data: {
						name: this.name
					}
				}).then((res) => {
					if (res.code == 0) {
						this.table.data = res.data.data
					}else{
						this.table.data = []
					}
				})
			}else {
				this.getList()
			}
		},
		// 刪除
		handleDEL(row) {
			this.$Modal.confirm({
				title: '提示',
				content: '是否删除',
				onOk: () => {
					this.$Rq.requestAuth({
						url: this.$Api.ordertypeDel,
						method: 'post',
						data: {
							id: row.id
						}
					}).then((res) => {
						this.$message.success(res.msg)
						if (res.code === 0) {
							this.getList();
							this.getTyleslist();
						}
					})
				},
				onCancel: () => {}
			});
		},
		// 关闭弹框
		handleModalClose() {
			this.form = {
				id:'',
				pid: '0', // 上级分贝
				name: '', // 分类名称
				sort: '' // 分类排序
			}
		},
		// 确定 新增  修改
		handleConfirm() {
			let url,data = this.form
			if (this.modalType == 'add') {
				url = this.$Api.ordertypeInsert
			}else {
				url = this.$Api.ordertypeUpdate
			}
			data.pid = this.form.pid ? this.form.pid : '0'
			
			this.$Rq.requestAuth({
				url,
				method: 'post',
				data
			}).then((res) => {
				this.$message.success(res.msg)
				if (res.code === 0) {
					this.getList();
					this.getTyleslist();
					this.handleModalClose();
					this.isShowModa = false
					console.log(this.form)
				}
			})
			
		},
		// 弹出modal  添加分类
		handleShowModal(type,row) {
			this.modalType = type
			if (type == 'edit') {
				this.form.id = row.id
				this.form.pid = row.pid
				this.$Rq.requestAuth({
					url: this.$Api.ordertypeOnList,
					method: 'get',
					data: {
						id: this.form.id
					}
				}).then((res) => {
					console.log(res.data)
					this.$message.success(res.msg)
					if (res.code == 0) {
						this.form.name = res.data.data[0].name
						this.form.sort = res.data.data[0].sort
					}
				})
			}
			this.isShowModa = true
		},
		// 分裂列表
		getTyleslist() {
			this.$Rq.requestAuth({
				url: this.$Api.ordertypeOnList,
				method: 'get'
			}).then((res) => {
				if (res.code == 0) {
					this.orderTypes = res.data.data;
				}else{
					this.orderTypes = []
				}
			})
		}
		
		
	}
}
</script>

<style scoped lang="scss">
.card-block {
	background-color: #FFFFFF;
	border-radius: 4px;
	padding: 15px;
}

.table-box {
	background-color: #FFFFFF;
	padding: 10px;
}

.add {
	padding: 20px 0;
}

.pg-btn-wrap {
	display: flex;
	align-items: center;
	
	.pg-btn {
		display: inline-block;
		vertical-align: middle;
		width: 120px;
		height: 35px;
		line-height: 35px;
		background: #fff;
		text-align: center;
		font-size: 14px;
		color: #999999;
		cursor: pointer;
		margin-right: 20px;
		text-decoration: none;
		border-radius: 3px;
		box-shadow: 0 2px 4px rgba(153, 153, 153, 0.5);
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
		
		&:last-of-type {
			margin-right: 0;
		}
		
		&.style1 {
			color: #fff;
			background: rgba(255, 101, 101, 1);
			box-shadow: 0 2px 4px rgba(255, 101, 101, 0.5);
		}
		
		&.style2 {
			color: #fff;
			background: rgba(101, 132, 255, 1);
			box-shadow: 0 2px 4px rgba(101, 132, 255, 0.5);
		}
		
		&.style3 {
			color: #fff;
			background: #FF9A65;
			box-shadow: 0 2px 4px rgba(255, 154, 101, 0.5);
		}
	}
	
	.loading-btn {
		height: 35px;
		cursor: not-allowed;
		opacity: 0.9;
	}
}
</style>
